// extracted by mini-css-extract-plugin
export var menuIcon = "_u1-0";
export var menuIconInline = "_u1-1";